// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  background-color: #f2f2f2;
  min-height: 100%;
  font-family: "Ruda", sans-serif;
}

.loginContainer {
  max-width: 330px;
  height: 50%;
  background-color: white;
  position: relative;
  left: 38%;
  text-align: center;
  margin-top: 12%;
  border-radius: 10px;
}

.loginH1 {
  background: #68dff0;
  color: #fff;
  padding: 25px 20px;
  text-align: center;
  background: #68dff0;
  border-radius: 5px 5px 0 0;
  color: #fff;
  font-size: 20px;
  text-transform: uppercase;
  font-weight: 300;
}

.loginUsername {
  width: 86%;
  height: 34px;
  font-size: 14px;
  line-height: 1.42857143;
  color: #555;
  background-color: #fff;
  background-image: none;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
  margin: 2% 4% 2% 4%;
  padding-left: 10px;
}

.error {
  padding-left: 24px;
  text-align: left;
  font-size: 12px;
  padding-bottom: 5px;
  color: red;
}

.forgotPassword {
  font-size: 12px;
  display: flex;
  justify-content: flex-start;
  margin-left: 24px;
  margin-top: 10px;
  text-decoration: none;
}

.loginButton {
  background: #68dff0;
  color: #fff;
  border-color: #48bcb4;
  padding: 6px 12px;
  font-size: 14px;
  font-weight: normal;
  line-height: 1.42857143;
  text-align: center;
  white-space: nowrap;
  border: 1px solid;
  border-radius: 4px;
  width: 90%;
  margin: 4% 4% 5% 4%;
  cursor: pointer;
}
.loginButton:hover {
  background: #51cac2;
}
.loginButton:active {
  background: #098092;
  border: 1px solid #02343b;
}

.notMatching {
  font-size: 12px;
  color: red;
  display: block;
  text-align: left;
  margin-left: 26px;
  margin-top: 0px;
}
`, "",{"version":3,"sources":["webpack://./src/components/Screens/Login/login.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,0BAA0B;EAC1B,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,eAAe;EACf,uBAAuB;EACvB,WAAW;EACX,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,gDAAgD;EAChD,wEAAwE;EACxE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,aAAa;EACb,2BAA2B;EAC3B,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,UAAU;EACV,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB","sourcesContent":["body {\n  background-color: #f2f2f2;\n  min-height: 100%;\n  font-family: \"Ruda\", sans-serif;\n}\n\n.loginContainer {\n  max-width: 330px;\n  height: 50%;\n  background-color: white;\n  position: relative;\n  left: 38%;\n  text-align: center;\n  margin-top: 12%;\n  border-radius: 10px;\n}\n\n.loginH1 {\n  background: #68dff0;\n  color: #fff;\n  padding: 25px 20px;\n  text-align: center;\n  background: #68dff0;\n  border-radius: 5px 5px 0 0;\n  color: #fff;\n  font-size: 20px;\n  text-transform: uppercase;\n  font-weight: 300;\n}\n\n.loginUsername {\n  width: 86%;\n  height: 34px;\n  font-size: 14px;\n  line-height: 1.42857143;\n  color: #555;\n  background-color: #fff;\n  background-image: none;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);\n  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;\n  margin: 2% 4% 2% 4%;\n  padding-left: 10px;\n}\n\n.error {\n  padding-left: 24px;\n  text-align: left;\n  font-size: 12px;\n  padding-bottom: 5px;\n  color: red;\n}\n\n.forgotPassword {\n  font-size: 12px;\n  display: flex;\n  justify-content: flex-start;\n  margin-left: 24px;\n  margin-top: 10px;\n  text-decoration: none;\n}\n\n.loginButton {\n  background: #68dff0;\n  color: #fff;\n  border-color: #48bcb4;\n  padding: 6px 12px;\n  font-size: 14px;\n  font-weight: normal;\n  line-height: 1.42857143;\n  text-align: center;\n  white-space: nowrap;\n  border: 1px solid;\n  border-radius: 4px;\n  width: 90%;\n  margin: 4% 4% 5% 4%;\n  cursor: pointer;\n}\n.loginButton:hover {\n  background: #51cac2;\n}\n.loginButton:active {\n  background: #098092;\n  border: 1px solid #02343b;\n}\n\n.notMatching {\n  font-size: 12px;\n  color: red;\n  display: block;\n  text-align: left;\n  margin-left: 26px;\n  margin-top: 0px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
